import React from 'react';
import { PricingStyled } from './styled';
import Layout from '@/components/layout';
import { BlockStack } from '@shopify/polaris';
import PricingOption from '@/pages/Pricing/components/PricingOption';
import PricingFAQs from './components/PricingFAQs.tsx';
import { useTranslation } from 'react-i18next';

interface PricingProps {}

const Pricing: React.FC<PricingProps> = () => {
  const { t } = useTranslation('pricing');

  return (
    <Layout title={t('pricing')}>
      <PricingStyled id="pricing-page">
        <BlockStack gap="500">
          <PricingOption />

          {/* <ComparePlan /> */}

          <PricingFAQs />
        </BlockStack>
      </PricingStyled>
    </Layout>
  );
};

export default Pricing;
